import { Controller } from '@hotwired/stimulus';
import Glide from '@glidejs/glide';

export default class extends Controller {
	connect() {
		new Glide('.glide__timeline', {
			type: 'slider',
			gap: 32,
			perView: 2.5,
			rewind: false,
			breakpoints: {
				// Settings for under 768px
				768: {
					perView: 1.25,
					gap: 16,
				},
				// Settings for under 1024px
				1280: {
					perView: 1.5,
					gap: 16,
				},
			},
		}).mount();
	}
}
